import { fromJS } from 'immutable';
import { toLower } from 'lodash';
import * as companyActions from '../actions/company';

export const COMPANY_SYNDICATION_STATES = {
  INITIAL: 0,
  SUPPORTED: 1,
  NO_SUPPORT: 2,
};

export const VALID_STATES = {
  INITIAL: 0,
  INVALID: 1,
  VALID: 2,
  NEED_REQUEST_ACCESS: 3,
  REFRESH_PAGE: 4,
};

const initialSearch = {
  searchID: null,
  resultID: null,
  searchLegID: null,
  loadID: null,
  searchByUser: null,
  tolls: null,
  selectedRouteToll: null,
  selectedRouteDistance: null,
  coordinates: null,
};

export const initialState = {
  currentCompany: {
    companyKey: null,
    company_id: null,
    logo: null,
    name: null,
    is_on_deck: null,
    validState: VALID_STATES.INITIAL,
    currentSearch: initialSearch,
    syndicationState: COMPANY_SYNDICATION_STATES.INITIAL,
    is_placeholder: null,
    overrideEmail: null,
    overridePhone: null,
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case companyActions.SET_CURRENT_COMPANY: {
      const validState = state.getIn(['currentCompany', 'validState']);
      return state
        .setIn(['currentCompany', 'validState'], validState)
        .setIn(
          ['currentCompany', 'companyKey'],
          toLower(action.payload.companyKey),
        )
        .setIn(['currentCompany', 'company_id'], action.payload.company_id)
        .setIn(
          ['currentCompany', 'overrideEmail'],
          action.payload.overrideEmail,
        )
        .setIn(
          ['currentCompany', 'overridePhone'],
          action.payload.overridePhone,
        )
        .setIn(['currentSearch'], initialSearch);
    }
    case companyActions.SET_COMPANY_METADATA: {
      const {
        is_on_deck,
        logo,
        name,
        syndicationState,
        is_placeholder,
        overrideEmail,
        overridePhone,
      } = action.payload;
      let validState =
        action.payload.is_on_deck === true
          ? VALID_STATES.VALID
          : action.payload.is_on_deck === null
          ? VALID_STATES.INITIAL
          : VALID_STATES.NEED_REQUEST_ACCESS;
      return state
        .setIn(['currentCompany', 'validState'], validState)
        .setIn(['currentCompany', 'is_on_deck'], is_on_deck)
        .setIn(['currentCompany', 'logo'], logo)
        .setIn(['currentCompany', 'name'], name)
        .setIn(['currentCompany', 'is_placeholder'], is_placeholder)
        .setIn(['currentCompany', 'syndicationState'], syndicationState)
        .setIn(['currentCompany', 'overrideEmail'], overrideEmail)
        .setIn(['currentCompany', 'overridePhone'], overridePhone);
    }
    case companyActions.SET_COMPANY_STATUS: {
      let validState =
        action.payload.is_on_deck === true
          ? VALID_STATES.VALID
          : action.payload.is_on_deck === null
          ? VALID_STATES.INITIAL
          : VALID_STATES.NEED_REQUEST_ACCESS;
      if (action.payload.is_on_deck === true) {
        return state.setIn(['currentCompany', 'validState'], validState);
      } else {
        return state.setIn(['currentCompany', 'validState'], validState);
      }
    }

    case companyActions.GET_COMPANY_STATUS_ERROR: {
      let validState;
      if (action.payload.status) {
        let status = action.payload.status;
        validState =
          status >= 400 && status < 500
            ? VALID_STATES.NEED_REQUEST_ACCESS
            : status >= 500
            ? VALID_STATES.REFRESH_PAGE
            : VALID_STATES.NEED_REQUEST_ACCESS;
      } else {
        validState =
          action.payload.is_on_deck === true
            ? VALID_STATES.VALID
            : action.payload.is_on_deck === null
            ? VALID_STATES.INITIAL
            : VALID_STATES.NEED_REQUEST_ACCESS;
      }
      return state.setIn(['currentCompany', 'validState'], validState);
    }

    case companyActions.GET_COMPANY_INFO_ERROR: {
      return state
        .setIn(['currentCompany', 'validState'], VALID_STATES.INVALID)
        .setIn(
          ['currentCompany', 'syndicationState'],
          COMPANY_SYNDICATION_STATES.NO_SUPPORT,
        );
    }

    case companyActions.GET_COMPANY_METADATA_ERROR: {
      const { status } = action.payload;
      let validState = VALID_STATES.INVALID;
      if (status >= 400 && status < 500) {
        //  show request access
        validState = VALID_STATES.NEED_REQUEST_ACCESS;
      } else if (status >= 500) {
        //  show message to refresh
        validState = VALID_STATES.REFRESH_PAGE;
      }
      return state
        .setIn(['currentCompany', 'validState'], validState)
        .setIn(
          ['currentCompany', 'syndicationState'],
          COMPANY_SYNDICATION_STATES.NO_SUPPORT,
        );
    }

    case companyActions.SET_COMPANY_INFO: {
      const {
        logo,
        name,
        syndicationState,
        is_placeholder,
        overrideEmail,
        overridePhone,
      } = action.payload;
      const validState = state.getIn(['currentCompany', 'validState']);
      return state
        .setIn(['currentCompany', 'logo'], logo)
        .setIn(['currentCompany', 'name'], name)
        .setIn(['currentCompany', 'is_placeholder'], is_placeholder)
        .setIn(['currentCompany', 'syndicationState'], syndicationState)
        .setIn(['currentCompany', 'overrideEmail'], overrideEmail)
        .setIn(['currentCompany', 'overridePhone'], overridePhone)
        .setIn(['currentCompany', 'validState'], validState);
    }

    case companyActions.SET_CURRENT_SEARCH: {
      return state
        .setIn(['currentSearch', 'searchID'], parseInt(action.payload.searchID))
        .setIn(['currentSearch', 'resultID'], null)
        .setIn(['currentSearch', 'searchLegID'], null)
        .setIn(['currentSearch', 'loadID'], null)
        .setIn(['currentSearch', 'tolls'], null);
    }

    case companyActions.RESET_CURRENT_SEARCH: {
      return state.setIn(['currentSearch'], initialSearch);
    }

    // case companyActions.SET_SELECTED_ROUTE_METADATA: {
    //   return state
    //     .setIn(['currentSearch', 'selectedRouteToll'], action.payload.toll)
    //     .setIn(
    //       ['currentSearch', 'selectedRouteDistance'],
    //       action.payload.distance,
    //     );
    // }

    case companyActions.SET_CURRENT_LOAD: {
      return state
        .setIn(['currentSearch', 'resultID'], fromJS(action.payload.resultID))
        .setIn(
          ['currentSearch', 'searchLegID'],
          fromJS(action.payload.searchLegID),
        )
        .setIn(['currentSearch', 'loadID'], fromJS(action.payload.loadID))
        .setIn(
          ['currentSearch', 'coordinates'],
          fromJS(action.payload.coordinates),
        )
        .setIn(['currentSearch', 'tolls'], fromJS(action.payload.tolls));
    }

    // case companyActions.TOLLS_FETCH_ERROR: {
    //   return state.setIn(['fetchingToll'], false);
    // }

    // case companyActions.TOLLS_FETCH_SUCCESS: {
    //   return state
    //     .setIn(
    //       ['currentSearch', 'tolls'],
    //       fromJS(_.get(action, 'payload', null)),
    //     )
    //     .setIn(
    //       ['currentSearch', 'selectedRouteToll'],
    //       fromJS(_.get(action, 'payload.optimalTotalTollCost', null)),
    //     )
    //     .setIn(['fetchingToll'], false);
    // }

    // case companyActions.TOLLS_FETCH: {
    //   return state
    //     .setIn(['currentSearch', 'selectedRouteToll'], null)
    //     .setIn(['currentSearch', 'selectedRouteDistance'], null)
    //     .setIn(['fetchingToll'], true);
    // }

    default: {
      return state;
    }
  }
};
